type LocaleMenuItem = {
  lang: string;
  label?: string;
  icon?: string;
  title?: string;
};

export const SITE_LOCALE_ORDER = [
  "en-US",
  "de-DE",
  "es-ES",
  "fr-FR",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "pt-PT",
  "zh-CN",
  "zh-TW",
  "ar-EG",
] as const;

const SITE_LOCALE_SET = new Set<string>(SITE_LOCALE_ORDER);

export const filterSiteLocales = (
  locales: LocaleMenuItem[],
): LocaleMenuItem[] => {
  const localeMap = new Map(locales.map((locale) => [locale.lang, locale]));

  return SITE_LOCALE_ORDER.map((lang) => localeMap.get(lang)).filter(
    (locale): locale is LocaleMenuItem => Boolean(locale),
  );
};

export const isSiteLocale = (lang: string) => SITE_LOCALE_SET.has(lang);

export const resolveSiteLocale = (lang?: string) => {
  const normalized = (lang || "").trim().toLowerCase();

  if (!normalized) {
    return "en-US";
  }

  const exactMatch = SITE_LOCALE_ORDER.find(
    (siteLocale) => siteLocale.toLowerCase() === normalized,
  );
  if (exactMatch) {
    return exactMatch;
  }

  if (normalized.startsWith("zh")) {
    return /(tw|hk|mo|hant)/.test(normalized) ? "zh-TW" : "zh-CN";
  }
  if (normalized.startsWith("pt")) {
    return "pt-PT";
  }
  if (normalized.startsWith("de")) {
    return "de-DE";
  }
  if (normalized.startsWith("es")) {
    return "es-ES";
  }
  if (normalized.startsWith("fr")) {
    return "fr-FR";
  }
  if (normalized.startsWith("it")) {
    return "it-IT";
  }
  if (normalized.startsWith("ja")) {
    return "ja-JP";
  }
  if (normalized.startsWith("ko")) {
    return "ko-KR";
  }
  if (normalized.startsWith("ar")) {
    return "ar-EG";
  }

  return "en-US";
};
